import styled from 'styled-components';

export const StyledConfidentialitySettings = styled.div`
   display: flex;
   flex-direction: column;
   gap: 16px;
`;
StyledConfidentialitySettings.displayName = 'StyledConfidentialitySettings';

export const StyledConfidentialityTable = styled.div`
   display: flex;
   flex-direction: column;
   gap: 8px;
   max-width: 380px;
`;
StyledConfidentialityTable.displayName = 'StyledConfidentialityTable';
